<template>
  <div class="right">
    <ul>
      <li class="wx">
        <div class="wx-img">
          <img :src="img.ABOUT_IMG_QR" alt="" height="140px" width="140px">
        </div>
      </li>
      <li class="top" id="returnTop" @click="backTop()"></li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      img: []
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.handleScroll)
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        this.img = response.data.ABOUT
        // console.log(this.img)
      })
  },
  methods: {
    backTop: function () {
      scrollTo(0, 0)
    }
  }
}
</script>

<style lang="less" scoped>
@media only screen and (max-width: 479px) {
  .right {
    display: none;
  }
}
.right {
  top:260px;
  right: 0px;
  width: 60px;
  height: 160px;
  z-index: 99;
  text-align: center;
  font-size: 18px;
  line-height: 60px;
  color: #fdfffc;
  // position: absolute;
  position: fixed;
  ul {
    list-style: none;
  }
  li {
    width: 60px;
    height: 60px;
    border-bottom: 1px solid #3197f0;
    background: #2c88d8;
    position: relative;
    transition: all .3s ease-in-out;
    cursor: pointer;
  }
  li:hover {
    background-color: #fdfffc;
    color: #2c88d8;
  }
  .wx {
    border-top-left-radius: 5px;
    background:#2c88d8 url(https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/img/right_ico.png) no-repeat;
    background-position: center -105px;
    .wx-img {
      width: 140px;
      height: 140px;
      border-radius: 5px;
      position: absolute;
      top: -10px;
      right: 60px;
      overflow: hidden;
      display: none;
      img {
        border: none;
        vertical-align: middle;
        max-width: 100%;
      }
    }
  }
  li:hover .wx-img {
    display: block;
  }
  .top {
    border-bottom-left-radius: 5px;
    border: none;
    background:#2c88d8 url(https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/img/right_ico.png) no-repeat;
    background-position: center -166px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/floatright.vue